import { ReactNode } from 'react';
import { Box, Divider, Stack, Typography, alpha } from '@mui/material';

export interface InfoListRow {
  key: string;
  label: ReactNode;
  value: ReactNode;
}

interface Props {
  icon: ReactNode;
  title: string;
  count?: number;
  badge?: ReactNode;
  rows: InfoListRow[];
}

const ROWS_VISIBLE_HEIGHT = 65;

export const InfoListCard = ({ icon, title, count, badge, rows }: Props) => (
  <Box p={2} borderRadius={1} border={1} borderColor="grey.200" bgcolor="#fff">
    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
      <Stack direction="row" alignItems="center" gap={0.5}>
        {icon}
        <Typography fontWeight={600}>{title}</Typography>
        {count != null && count > 1 && (
          <Box px={0.75} borderRadius={10} sx={{ bgcolor: theme => alpha(theme.palette.primary.main, 0.1) }}>
            <Typography variant="caption" fontWeight={600} color="primary.main">
              {count}
            </Typography>
          </Box>
        )}
      </Stack>
      {badge}
    </Stack>
    <Stack
      divider={<Divider />}
      minHeight={ROWS_VISIBLE_HEIGHT}
      maxHeight={ROWS_VISIBLE_HEIGHT}
      sx={{ overflowY: 'auto' }}
    >
      {rows.map(row => (
        <Stack key={row.key} direction="row" alignItems="center" justifyContent="space-between" gap={2} py={0.75}>
          <Typography variant="body2" color="text.secondary">
            {row.label}
          </Typography>
          <Typography variant="body2" fontWeight={600} whiteSpace="nowrap">
            {row.value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  </Box>
);
